module.exports = __webpack_public_path__ + "static/media/honduras.6b8d1caa.svg";